const pad = (value, width, z) => {
  const zz = z || '0';
  const valueStr = value.toString();
  return valueStr.length >= width ? valueStr : new Array(width - valueStr.length + 1).join(zz) + valueStr;
};

const formatSeconds = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  return `${pad(hrs, 2)}:${pad(mins, 2)}:${pad(secs, 2)}`;
};

export default formatSeconds;
